<template>
    <ModalLayout ref="self" class="WorkingMemory" :collapsed="collapsed" @request-collapse="$emit('request-collapse')">
        <div slot="header" class="header">
            <div class="headerTitle">
                {{ $t('headerTitle') }}
            </div>
        </div>
        <CollapsedContentLayout
            slot="collapsedContent"
            :color="color"
            :title="$t('collapsedTitle')"
            :subtitle="$t('collapsedSubtitle')"
            :button-label="$t('collapsedButtonLabel')"
            @xclick="$emit('request-expand')"
            @click="startTest()"
        />

        <TextBlock slot="content">
            <!-- <h2>Test arbeidshukommelsen</h2> -->
            <p>Hva om du kunne trene hjernen din til å huske dobbelt så mye som du gjør nå?</p>

            <p>
                Heldigvis er det ikke noe hard trening som skal til, men heller lek med morsomme husketeknikker som gir
                direkte fordel i hverdagen din. Den delen av hjernen som er ansvarlig for hukommelse er nemlig også
                ansvarlig for følelser. Sagt med andre ord: dersom det ikke er gøy, husker vi dårlig!
            </p>

            <p>Men først, la oss teste hvor mye du husker uten husketeknikker:</p>
        </TextBlock>
        <div slot="content" class="footer">
            <PlainButton class="button" :color="color" @click="startTest()">
                Start
            </PlainButton>
        </div>
    </ModalLayout>
</template>

<translations>
  collapsedTitle: 'Arbeidshukommelse'
  collapsedSubtitle: 'Test arbeidshukommelsen & lær en husketeknikk'
  collapsedButtonLabel: 'Start'

  headerTitle: 'Test arbeidshukommelsen'
</translations>

<script>
import gameHelper from '@/modules/games-shared/game-helper';
import ModalLayout from './ModalLayout';
import PlainButton from './PlainButton';
import TextBlock from './TextBlock';
import CollapsedContentLayout from './CollapsedContentLayout';
import gameTheme from '../game-theme-working-memory';

export default {
    components: { ModalLayout, PlainButton, TextBlock, CollapsedContentLayout },
    props: {
        collapsed: {
            type: Boolean
        }
    },
    created() {
        this.color = '#2EA79E';
    },
    methods: {
        startTest() {
            this.$emit('signal', 'done');
            const settings = {
                numberOfItems: 10,
                numberOfFakeItems: 3,
                itemMemorizeTimeLimit: 5,
                itemQuizTimeLimit: 10,

                quizShowQuestionsSequentially: true,
                quizRandomizeQuestionOrder: true,
                quizDropQuestionOnFail: true,
                disableLives: true
            };

            gameHelper.createPracticeSession({
                gameId: 'shopping',
                testName: 'memoryOnboardingTestA',
                theme: gameTheme,
                exitUrl: this.$route.path,
                resultUrl: this.$route.path,
                sessionOptions: settings,
                navigate: true
            });
        },
        getCollapsedHeight() {
            return this.$refs.self.getCollapsedHeight();
        }
    }
};
</script>

<style lang="scss" scoped>
.WorkingMemory {
}
.header {
    padding: 1.5em;
}
.headerTitle {
    font-size: 140%;
    font-weight: bold;
    text-align: center;
}
.footer {
    display: flex;
    justify-content: center;
    padding: 1em;
}
</style>
